import FeedbackPage from "@components/FeedbackPage"

export default function ChallengesOvercome() {
  return (
    <FeedbackPage
      emoji="💪"
      titleKey="pages.onboarding.challengesOvercome.heading"
      textKey="pages.onboarding.challengesOvercome.info"
      buttonKey="pages.onboarding.challengesOvercome.button"
    />
  )
}
